import { put, takeLatest, call } from "redux-saga/effects";
import HojasQuirurgicasActions, {
  Types as HojasQuirurgicasTypes,
} from "../../stores/hospitalizacion/hojasQuirurgicas/Actions";
import HojasQuirurgicasService from "../../services/hospitalizacion/HojasQuirurgicasService";
import ResponseCode from "../../services/ResponseCode";
import {
  construirUrlPacientesIngresados,
} from "../../containers/hospitalizacion/utils/PacientesIngresadosUtils";

function* consultarPaciente(request) {
  yield put(HojasQuirurgicasActions.consultarPacienteLoading());

  try {
    const url = construirUrlPacientesIngresados(
      request.payload.numeroMedico, 
      request.payload.params,
      request.payload.pagina,
      request.payload.tamano
    );
    
    const consultarPacienteResponse = yield call(
      HojasQuirurgicasService.obtenerPacientesIngresados,
      {
        url,
        requestHeaders: request.payload.requestHeaders
      }
    );

    if (consultarPacienteResponse?.respuesta?.codigo !== 200) {
      yield put(
        HojasQuirurgicasActions.consultarPacienteFailure({
          codigo: consultarPacienteResponse?.respuesta?.codigo || ResponseCode.SERVER_ERROR.code,
          mensaje: consultarPacienteResponse?.respuesta?.mensaje || "Error al consultar el paciente",
        })
      );
      return;
    }

    yield put(
      HojasQuirurgicasActions.consultarPacienteSuccess(consultarPacienteResponse)
    );
  } catch (error) {
    yield put(
      HojasQuirurgicasActions.consultarPacienteFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: "Error al obtener el paciente",
      })
    );
  }
}

function* consultarPacientes(request) {
  yield put(HojasQuirurgicasActions.consultarPacientesLoading());

  try {
    const url = construirUrlPacientesIngresados(
      request.payload.numeroMedico, 
      request.payload.params,
      request.payload.pagina,
      request.payload.tamano
    );
    
    const consultarPacientesResponse = yield call(
      HojasQuirurgicasService.obtenerPacientesIngresados,
      {
        url,
        requestHeaders: request.payload.requestHeaders
      }
    );

    if (consultarPacientesResponse?.respuesta?.codigo !== 200) {
      yield put(
        HojasQuirurgicasActions.consultarPacientesFailure({
          codigo: consultarPacientesResponse?.respuesta?.codigo || ResponseCode.SERVER_ERROR.code,
          mensaje: consultarPacientesResponse?.respuesta?.mensaje || "Error al consultar los pacientes",
        })
      );
      return;
    }

    yield put(
      HojasQuirurgicasActions.consultarPacientesSuccess(consultarPacientesResponse)
    );
  } catch (error) {
    yield put(
      HojasQuirurgicasActions.consultarPacientesFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: "Error al consultar los pacientes",
      })
    );
  }
}

function* validarHojaQuirurgica(request) {
  yield put(HojasQuirurgicasActions.validarHojaQuirurgicaLoading());

  try {
    const validarHojaQuirurgicaResponse = yield call(
      HojasQuirurgicasService.validarHojaQuirurgica,
      request.payload
    );

    if (validarHojaQuirurgicaResponse?.respuesta?.codigo !== 200) {
      yield put(
        HojasQuirurgicasActions.validarHojaQuirurgicaFailure({
          codigo: validarHojaQuirurgicaResponse?.respuesta?.codigo || ResponseCode.SERVER_ERROR.code,
          mensaje: validarHojaQuirurgicaResponse?.respuesta?.mensaje || "Error al validar la hoja quirúrgica",
        })
      );
      return;
    }

    yield put(
      HojasQuirurgicasActions.validarHojaQuirurgicaSuccess(validarHojaQuirurgicaResponse)
    );
  } catch (error) {
    yield put(
      HojasQuirurgicasActions.validarHojaQuirurgicaFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: "Error al validar la hoja quirúrgica",
      })
    );
  }
}

function* consultarEstatusHojasQX(request) {
  yield put(HojasQuirurgicasActions.consultarEstatusHojasQXLoading());

  try {
    const consultarEstatusHojasQXResponse = yield call(
      HojasQuirurgicasService.consultarEstatusHojasQX,
      request.payload
    );

    if (consultarEstatusHojasQXResponse?.respuesta?.codigo !== 0) {
      yield put(
        HojasQuirurgicasActions.consultarEstatusHojasQXFailure({
          codigo: consultarEstatusHojasQXResponse?.respuesta?.codigo || ResponseCode.SERVER_ERROR.code,
          mensaje: consultarEstatusHojasQXResponse?.respuesta?.mensaje || "Error al consultar el estatus de las hojas QX",
        })
      );
      return;
    }

    yield put(
      HojasQuirurgicasActions.consultarEstatusHojasQXSuccess(consultarEstatusHojasQXResponse)
    );
  } catch (error) {
    yield put(
      HojasQuirurgicasActions.consultarEstatusHojasQXFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: "Error al consultar el estatus de las hojas QX",
      })
    );
  }
}

function* registrarCobertura(request) {
  yield put(HojasQuirurgicasActions.registrarCoberturaLoading());

  try {
    const registrarCoberturaResponse = yield call(
      HojasQuirurgicasService.registrarCobertura,
      request.payload
    );

    if (registrarCoberturaResponse?.respuesta?.codigo !== 200) {
      yield put(
        HojasQuirurgicasActions.registrarCoberturaFailure({
          codigo: registrarCoberturaResponse?.respuesta?.codigo || ResponseCode.SERVER_ERROR.code,
          mensaje: registrarCoberturaResponse?.respuesta?.mensaje || "Error al registrar la cobertura",
        })
      );
      return;
    }

    yield put(
      HojasQuirurgicasActions.registrarCoberturaSuccess(registrarCoberturaResponse)
    );
  } catch (error) {
    yield put(
      HojasQuirurgicasActions.registrarCoberturaFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: "Error al registrar la cobertura",
      })
    );
  }
}

function* consultarDetalleAnexos(request) {
  yield put(HojasQuirurgicasActions.consultarDetalleAnexosLoading());

  try {
    const consultarDetalleAnexosResponse = yield call(
      HojasQuirurgicasService.consultarDetalleAnexos,
      request.payload
    );

    if (consultarDetalleAnexosResponse?.respuesta?.codigo !== 200) {
      yield put(
        HojasQuirurgicasActions.consultarDetalleAnexosFailure({
          codigo: consultarDetalleAnexosResponse?.respuesta?.codigo || ResponseCode.SERVER_ERROR.code,
          mensaje: consultarDetalleAnexosResponse?.respuesta?.mensaje || "Error al consultar el detalle de anexos",
        })
      );
      return;
    }

    yield put(
      HojasQuirurgicasActions.consultarDetalleAnexosSuccess(consultarDetalleAnexosResponse)
    );
  } catch (error) {
    yield put(
      HojasQuirurgicasActions.consultarDetalleAnexosFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: "Error al consultar el detalle de anexos",
      })
    );
  }
}

function* consultarDetalleCobertura(request) {
  yield put(HojasQuirurgicasActions.consultarDetalleCoberturaLoading());

  try {
    const consultarDetalleCoberturaResponse = yield call(
      HojasQuirurgicasService.consultarDetalleCobertura,
      request.payload
    );

    if (consultarDetalleCoberturaResponse?.respuesta?.codigo !== 200) {
      yield put(
        HojasQuirurgicasActions.consultarDetalleCoberturaFailure({
          codigo: consultarDetalleCoberturaResponse?.respuesta?.codigo || ResponseCode.SERVER_ERROR.code,
          mensaje: consultarDetalleCoberturaResponse?.respuesta?.mensaje || "Error al consultar el detalle de cobertura",
        })
      );
      return;
    }

    yield put(
      HojasQuirurgicasActions.consultarDetalleCoberturaSuccess(consultarDetalleCoberturaResponse)
    );
  } catch (error) {
    yield put(
      HojasQuirurgicasActions.consultarDetalleCoberturaFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: "Error al consultar el detalle de cobertura",
      })
    );
  }
}

const exportedArray = [
  takeLatest(HojasQuirurgicasTypes.CONSULTAR_PACIENTE, consultarPaciente),
  takeLatest(HojasQuirurgicasTypes.CONSULTAR_PACIENTES, consultarPacientes),
  takeLatest(HojasQuirurgicasTypes.VALIDAR_HOJA_QUIRURGICA, validarHojaQuirurgica),
  takeLatest(HojasQuirurgicasTypes.CONSULTAR_ESTATUS_HOJAS_QX, consultarEstatusHojasQX),
  takeLatest(HojasQuirurgicasTypes.REGISTRAR_COBERTURA, registrarCobertura),
  takeLatest(HojasQuirurgicasTypes.CONSULTAR_DETALLE_ANEXOS, consultarDetalleAnexos),
  takeLatest(HojasQuirurgicasTypes.CONSULTAR_DETALLE_COBERTURA, consultarDetalleCobertura),
];

export default exportedArray;
